<template>
  <div class="meeting">
    <el-dialog
      class="home-background"
      :visible.sync="dialogVisible"
      width="45%"
      :before-close="handleClose"
    >
      <img :src="currUrl" />
    </el-dialog>

    <img
      class="meeting-img"
      src="/static/img/meeting2023/meeting2023.png"
      alt=""
    />

    <div class="meeting-img-div">
      <el-carousel
        indicator-position="none"
        class="meeting-img-container"
        :interval="4000"
        type="card"
        height="550px"
      >
        <el-carousel-item
          class="meeting-img-container-item"
          v-for="item in imgList"
          :key="item.url"
        >
          <img
            @click="model(item.url)"
            class="meeting-img-min"
            :src="item.url"
            alt=""
            :key="item.url"
          />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="meeting-video">
      <h1 class="meeting-video-h1">COC2023 开幕视频</h1>
      <video
        class="meeting-video-container"
        src="https://c-mbs.oss-cn-beijing.aliyuncs.com/Video/COC2023.mp4"
        controls="controls"
      >
        您的浏览器暂时不支持video标签
      </video>
    </div>

    <div class="news">
      <div class="news-content">
        <h2 class="news-content-h2">
          深入融合肥胖相关5大领域，第二届中国肥胖大会举行
        </h2>

        <span class="news-content-span">
          “我国减重与代谢外科患者数量达到第一个万例，用了2018-2021年3年时间，而第二个万例仅用了2021-2022年1年。”中国肥胖大会主席、首都医科大学附属北京友谊医院副院长张忠涛教授说。
        </span>

        <span class="news-content-span">
          7月29-30日，由国家消化系统疾病临床医学研究中心(北京)、北京医师协会减重与代谢专科医师分会及相关学术组织联合举办的第二届中国肥胖大会
          (COC2023)在北京国家会议中心举行。
        </span>

        <div class="news-img">
          <img src="/static/img/news/new2023.png" alt="" />
          <span>中国肥胖大会 科学减重·“蓝蜻蜓”行动启动</span>
        </div>

        <h2>减重与代谢外科5年数据报告首次发布</h2>
        <h2>科学减重·“蓝蜻蜓”行动开启</h2>
        <span class="news-content-span">
          基于对20余个省市、80余家中心的2万余例的患者分析，会上首次发布了减重与代谢外科5年数据报告。张忠涛教授介绍，我国减重与代谢外科建设发展格局面临着两方面的挑战：一是如何促进优质医疗资源扩容和区域均衡布局发展，二是如何提高临床专科诊疗能力和医疗质量安全水平。
        </span>
        <div class="news-img">
          <img src="/static/img/news/news2023-2.png" alt="" />
          <span
            >中国肥胖大会主席、首都医科大学附属北京友谊医院副院长张忠涛教授</span
          >
        </div>

        <span class="news-content-span">
          “未来要以多学科融合促进技术创新发展，健全专科医疗质量安全管理体系。”张忠涛建议，以前瞻性多中心临床研究为抓手，聚焦“以疾病为中心”、“以减重为中心的降糖治疗”、“创新减重医疗器械”等维度，提升减重与代谢外科专科临床诊疗能力。与此同时，以北京市为立足点，聚焦专科健康发展和医疗质量提升，为患者提供高质量、高安全的减重与代谢手术治疗，保障医患切身利益。
        </span>
        <span class="news-content-span">
          会议现场启动了科学减重·“蓝蜻蜓”行动，旨在通过肥胖教育、肥胖热线、肥胖救助三大公益项目，进一步传递科学减重理念。《减重与代谢外科标准数据集》同场发布，开启我国减重与代谢外科数据建设发展的首次探索。
        </span>

        <h2>5成以上成年人超重</h2>
        <h2>各地减重手术量与肥胖人口分布失衡</h2>
        <span class="news-content-span">
          “我国肥胖人群越来越多，成年人中50%以上属于超重肥胖，而且肥胖人群上升的比例甚至要超过超重人群的比例。”张忠涛教授表示，肥胖症已成为我国重大公共卫生问题。预计到2030年，我国超重肥胖相关卫生支出将约占全国医疗费用总额的22%。
        </span>
        <span class="news-content-span">
          “在我的门诊当中，70%以上的患者BMI在30以上，并且这个胖度还在不断增加，BMI50、60的越来越多。”北京协和医院营养科陈伟教授分享了自己接诊患者的变化情况，称近两年其门诊基本转型到为肥胖人群服务，接诊的大多是因胖生病或因为肥胖处于危险状态的患者。
        </span>
        <span class="news-content-span">
          大会执行主席、北京友谊医院减重与代谢外科主任张鹏教授介绍，我国肥胖人群的地域分布并不均衡，由北向南呈递减趋势。“从西方国家的情况来看，减重手术的量和当地肥胖人口的量呈一个平行状态，但在我国还没有达到这一点，内陆地区及经济欠发达地区减重手术的实行量也不如沿海地区。”张鹏教授认为，需建立一套完备的质量控制体系，通过培训，将该体系在全国范围内推广，让更多患者获益。
        </span>

        <h2>10年13本共识指南发布</h2>
        <h2>中国肥胖多学科诊疗迈向深度融合新时代</h2>

        <span class="news-content-span">
          大会现场，来自临床营养学、内分泌代谢学、心血管病学、减重与代谢外科学、代谢生物学等不同学科的专家，围绕肥胖防治的多学科深度合作与减重产品的临床研究成果转化展开了讨论。
        </span>
        <span class="news-content-span">
          “肥胖本身就是一种疾病，它还可以引起相关各个学科的多种疾病，而且这些疾病是互相促进的。因此对于肥胖的治疗及临床研究也需要多学科的深度合作与密切融合。”张忠涛介绍，2003年至今，我国已发布13本肥胖防治相关共识指南（续），下一步需建立从成人到儿童、从内科到外科、从预防到管理的全人群、全生命周期体重管理，来降低疾病发病率。
        </span>
        <div class="news-img">
          <img src="/static/img/news/news2023-3.png" alt="" />
          <span>大会执行主席、北京大学人民医院内分泌科主任纪立农教授</span>
        </div>

        <span class="news-content-span">
          大会执行主席、北京大学人民医院内分泌科主任纪立农教授谈到，近几年减重药物的开发方面有了很大进步，一些药物不仅通过早期的临床研究成功上市，在上市后还开展了长期的心血管保护研究及安全性研究，并在临床实践中看到了很好的减重效果。
        </span>

        <span class="news-content-span">
          “很多基础的科学研究一定要和产业侧相配合。”大会共同主席、天津医科大学公共卫生学院房中则教授举例说道，很多专家都在研究肠道菌群和肥胖的预防、诊疗与干预问题，认为肥胖可能和肠道菌群密切相关。“这些科研成果，我们更加希望从产业侧进行转化，让肥胖患者甚至是全人群都可以从中获益。”
        </span>

        <span class="news-content-span">
          “高血压是肥胖的一种表现，这是我们从学科发展上重新认识肥胖问题的一个重要切入点。”大会执行主席、中国医学科学院阜外医院心血管内科张宇清教授谈到，基于这一认知，在治疗高血压的过程中同时进行生活方式指导及药物干预，有可能更加有效、容易地解决高血压问题。
        </span>

        <span class="news-content-span">
          大会倡导多领域全行业交叉融合，设置包括开幕式暨大会主题报告、各专业专长会议、多学科交叉、最新临床指南、最新临床研究成果、及产学研等在内的40余场论坛。
        </span>

        <div>
          本文转自人民日报健康客户端
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="wrap">
        <a href="#" class="f-logo wow fadeInLeft"
          ><img src="/static/img/f-logo.png"
        /></a>
        <!--			<p class="wow fadeInRight">地址：北京丰台区汉威广场二区1号楼6M层</p>-->
        <p class="wow fadeInRight">
          Copyright © 2017-2020 大中华减重与代谢外科数据平台京ICP备17044059号
        </p>
        <p>
          平台支持：<a target="_blank" href="http://www.edocdata.com/"
            >北京易得医数科技有限责任公司</a
          >
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import VueCountUp from "vue-countupjs";
import { WOW } from "wowjs";

export default {
  components: { VueCountUp },
  name: "meeting2023",
  data() {
    return {
      imgList: [
        {
          url: require("../../static/img/meeting2023/COC2023-1.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-2.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-3.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-4.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-5.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-6.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-7.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-8.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-9.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-10.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-11.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-12.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-13.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-14.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-15.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-16.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-17.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-18.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-19.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-20.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-21.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-22.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-23.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-24.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-25.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-26.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-27.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-28.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-29.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-30.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-31.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-32.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-33.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-34.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-35.png")
        },
        {
          url: require("../../static/img/meeting2023/COC2023-36.png")
        }
      ],
      dialogVisible: false,
      currUrl: ""
    };
  },
  methods: {
    model(url) {
      // console.log(url);
      this.currUrl = url;
      this.dialogVisible = true;
    },
    handleClose() {
      this.currUrl = "";
      this.dialogVisible = false;
    }
  },
  mounted() {
    this.$nextTick(() => {
      var wow = new WOW({
        live: false
      });
      wow.init();
    });
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/meeting2023.vue